export const TASK_MANAGER_TAB = 'Task manager';
